import React from 'react';
import Ediv from './../helper/Ediv';
import RollingText from './../helper/RollingText';

const getDir = (current, arg, getParent) => {
  let lsDir = current;

  if(arg) {
    let dir = arg.split('/');

    if(dir[0] !== '') {
      let tempDir = JSON.parse(JSON.stringify(current));
      dir = [''].concat(tempDir.concat(dir));
    }

    if(dir.length > 1 && dir[dir.length - 1] === '') { // remove last empty element
      dir.pop();
    }

    lsDir = dir.slice(1);
  }

  if(getParent) lsDir.push('..');

  let contains = (l, w) => {
    let doesContain = false;
    l.map(a => {
      if(a === w) doesContain = true;
      return a;
    });
    return doesContain;
  };

  while(contains(lsDir, '..')) {
    lsDir.map((a, i, f) => {
      if(a === '..') {
        f.splice(i-1, 2);
      }
      return a;
    });
  }

  return lsDir;
};

const ls = (args, terminal, app) => {

  let lsDir = getDir(terminal.currentDirectory, args[1]);
  let ls = terminal.fs.ls(lsDir);

  let promise;
  let toPrint = {
    'isdir': ls => {
      let resolve;
      promise = new Promise(res => resolve = res);

      let types = {
        'file': name => (<RollingText app={app} text={name} resolve={resolve} className="item-file" key={name}></RollingText>),
        'dir': name => (<RollingText app={app} text={`/${name}`} resolve={resolve} className="item-dir" key={name}></RollingText>),
        'link': name => (<RollingText app={app} text={name} resolve={resolve} className="item-link" key={name}></RollingText>)
      };

      let items = [];
      Object.keys(ls.content).map(a => {
        let item = ls.content[a];
        items.push(types[item.type](a));
        return a; // array-callback-return
      });
      return (<div>{ items }</div>);
    },
    'notfound': ls => (<Ediv>ls: {args[1]}: No such file or directory</Ediv>),
    'isfile': ls => (<Ediv>ls: {args[1]}: Not a directory</Ediv>),
    'islink': ls => (<Ediv>ls: {args[1]}: Not a directory</Ediv>)
  }[ls.status](ls);

  return {
    toPrint,
    promise
  };
};

const cd = (args, terminal, app) => {
  if(!args[1]) {
    terminal.currentDirectory = [];
    return (<div></div>);
  } else {
    var cdDir = getDir(terminal.currentDirectory, args[1]);
    let ls = terminal.fs.ls(cdDir);

    return {
      'isdir': () => {
        terminal.currentDirectory = cdDir;
        return (<div></div>);
      },
      'notfound': () => (<Ediv>cd: {args[1]}: No such file or directory</Ediv>),
      'isfile': () => (<Ediv>cd: {args[1]}: Not a directory</Ediv>),
      'islink': () => (<Ediv>cd: {args[1]}: Not a directory</Ediv>)
    }[ls.status]();
  }
};

const open = (args, terminal, app) => {
  if(!args[1]) {
    return (<div>usage: open link</div>);
  } else {
    var openDir = getDir(terminal.currentDirectory, args[1]);
    let ls = terminal.fs.ls(openDir);

    return {
      'isdir': () => (<Ediv>open: {args[1]}: Is a directory</Ediv>),
      'notfound': () => (<Ediv>open: {args[1]}: No such file or directory</Ediv>),
      'isfile': () => (<Ediv>open: {args[1]}: Is a file</Ediv>),
      'islink': () => {
        window.open(ls.content);
        return (<div></div>);
      }
    }[ls.status]();
  }
};

const pwd = (args, terminal, app) => {
  let resolve;
  let promise = new Promise(res => resolve = res);
  let text = terminal.getDirectory();

  return {
    toPrint: (<RollingText app={app} resolve={ resolve } text={ text } className="item-dir"></RollingText>),
    promise,
  };
};

const cat = (args, terminal, app) => {
  if(!args[1]) {
    return (<div>usage: cat file</div>);
  }

  let read = (ls) => ls.content;

  var catDir = getDir(terminal.currentDirectory, args[1]);
  let ls = terminal.fs.ls(catDir);

  let content = read(ls);

  let resolve;
  let promise = new Promise(res => resolve = res);

  return {
    toPrint: {
      'isdir': () => {
        resolve();
        return (<Ediv>cat: {args[1]}: Is a directory</Ediv>);
      },
      'notfound': () => {
        resolve();
        return (<Ediv>cat: {args[1]}: No such file or directory</Ediv>);
      },
      'islink': () => (<RollingText app={app} text={content} resolve={resolve} type={`pre`} />),
      'isfile': () => (<RollingText app={app} text={content} resolve={resolve} type={`pre`} />),
    }[ls.status](ls),
    promise
  }
};

const touch = (args, terminal, app) => {
  if(!args[1]) {
    return (<div>usage: touch file</div>);
  } 

  let touchDir = getDir(terminal.currentDirectory, args[1], true);
  let ls = terminal.fs.ls(touchDir);
  let name = args[1].split('/').pop();

  let collidingFile = terminal.fs.ls(getDir(terminal.currentDirectory, args[1]));
  if(collidingFile.status !== 'notfound') {
    return {
      'isdir': (<Ediv>touch: { args[1] }: Is a directory</Ediv>),
      'isfile': (<Ediv>touch: { args[1] }: Is a file</Ediv>),
      'islink': (<Ediv>touch: { args[1] }: Is a link</Ediv>),
    }[collidingFile.status];
  }

  return {
    'isdir': ls => {
      ls.content[name] = {
        type: 'file',
        content: ''
      };

      return (<div></div>);
    }
  }[ls.status](ls);
};

const rm = (args, terminal, app) => {
  if(!args[1]) {
    return (<div>usage: rm file</div>);
  }

  let name = args[1].split('/').pop();
  if(name === '..' || name === '.') {
    return (<div>rm: "." and ".." may not be removed</div>);
  }

  let rmDir = getDir(terminal.currentDirectory, args[1], true);
  let ls = terminal.fs.ls(rmDir);

  if(terminal.fs.ls(getDir(terminal.currentDirectory, args[1])).status === 'notfound') {
    return (<Ediv>rm: { args[1] }: No such file or directory</Ediv>);
  }

  delete ls.content[name];
  return (<div></div>);
};

const sh = (args, terminal, app) => {
  if(!args[1]) {
    return (<div>usage: sh file</div>);
  }

  let shDir = getDir(terminal.currentDirectory, args[1]);
  let ls = terminal.fs.ls(shDir);

  return {
    'notfound': () => (<Ediv>sh: { args[1] }: No such file or directory</Ediv>),
    'isdir': () => (<Ediv>sh: { args[1] }: Is a directory</Ediv>),
    'islink': () => (<Ediv>sh: { args[1] }: Is a link</Ediv>),
    'isfile': ls => {
      terminal.queue.push(ls.content);
      return <div></div>
    }
  }[ls.status](ls);
};

export { ls, cd, open, pwd, cat, touch, rm, sh };


// WEBPACK FOOTER //
// ./src/commands/dir.js